// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonLoader_skeleton__2m700","left":"SkeletonLoader_left__Znwzk"};